import React from 'react'
import AttachTagItemPage from './AttachTagItemPage'
import '../styles/index.scss'

function AttachTagItemPageContainer() {
    return (
        <div className='AttachTagItemPageContainer'>
            <AttachTagItemPage/>
        </div>
    )
}

export default AttachTagItemPageContainer
